var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00041 5.33337C3.4308 5.33337 2.9241 5.69522 2.73924 6.23399C2.55438 6.77277 2.7322 7.36947 3.18182 7.71918L15.1818 17.4083C15.6633 17.7828 16.3375 17.7828 16.819 17.4083L28.819 7.71918C29.2686 7.36947 29.4464 6.77277 29.2616 6.23399C29.0767 5.69522 28.57 5.33337 28.0004 5.33337H4.00041ZM16.0004 14.6667L7.88645 8.00004H24.1144L16.0004 14.6667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 12C5.33366 11.2637 4.73671 10.6667 4.00033 10.6667C3.26395 10.6667 2.66699 11.2637 2.66699 12V25.3334C2.66699 26.0698 3.26395 26.6667 4.00033 26.6667H28.0003C28.7367 26.6667 29.3337 26.0698 29.3337 25.3334V12C29.3337 11.2637 28.7367 10.6667 28.0003 10.6667C27.2639 10.6667 26.667 11.2637 26.667 12V24H5.33366V12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.2c511d0081c4200322ac9e5f098f6409.svg";
export { ForwardRef as ReactComponent };